import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Base64: { input: string; output: string; }
  BigDecimal: { input: number; output: number; }
  Date: { input: string; output: string; }
  DateTime: { input: any; output: any; }
  Long: { input: number; output: number; }
}

/** Информация об аккаунте */
export interface Account {
  __typename?: 'Account';
  /** Номер счета */
  clientAccount: Scalars['String']['output'];
  /** Имя клиента */
  clientName: Scalars['String']['output'];
  /** Список валют */
  currencies: Array<Currency>;
}

/** Доступный счет у организации(как правило получаем как список все доступные счета) */
export interface AvailableAccount {
  __typename?: 'AvailableAccount';
  /** Номер счета */
  account: Scalars['String']['output'];
  /** Список валют в виде iso_num */
  currencies: Array<Scalars['Long']['output']>;
}

/** Для формирования выписке по карт счету */
export interface CardStatementOrderDto {
  /** Номер счета */
  account: Scalars['String']['input'];
  /** Операции в выписке от(до какой даты операции) */
  endDate: Scalars['Date']['input'];
  /** Форматы файлов XLSX, PDF и TXT (1C 1.03) */
  fileFormat: FileFormat;
  /** На каком языке формировать выписку */
  language: Language;
  /** Айди организации */
  partyId: Scalars['Long']['input'];
  /** Операции в выписке от(с какой даты операции) */
  startDate: Scalars['Date']['input'];
}

/** Представление валюты */
export interface Currency {
  __typename?: 'Currency';
  /** Входящий остаток */
  incomingBalance: Scalars['BigDecimal']['output'];
  /** Международное название валюты */
  isoName: Scalars['String']['output'];
  /** Международный номер валюты */
  isoNum: Scalars['Long']['output'];
  /** Фактический исходящий остаток */
  outgoingBalance: Scalars['BigDecimal']['output'];
  /** Список платежей */
  payments: Array<Payment>;
  /** Планируемый исходящий остаток */
  planBalance: Scalars['BigDecimal']['output'];
  /** Итого оборотов */
  totalCredit: Scalars['BigDecimal']['output'];
  /** Итого оборотов */
  totalDebit: Scalars['BigDecimal']['output'];
}

/** Представление сформированного файла */
export interface File {
  __typename?: 'File';
  /** тип файла(pdf, txt и т.п) */
  contentType: Scalars['String']['output'];
  /** Файл ввиде base64 */
  data: Scalars['Base64']['output'];
  /** Название файла */
  fileName: Scalars['String']['output'];
}

/** Форматы файлов, сформированных выписок */
export enum FileFormat {
  Mt_940 = 'MT_940',
  Pdf = 'PDF',
  Txt = 'TXT',
  Xlsx = 'XLSX',
  Xml = 'XML'
}

/** Поддерживаемые языки выписок */
export enum Language {
  En = 'EN',
  Kg = 'KG',
  Ru = 'RU'
}

export interface Mutation {
  __typename?: 'Mutation';
  /** Запрос на формирование выписки */
  order: Statement;
  /** Сгенерировать пдф выписку по карт счету */
  orderCardStatement: File;
  /** Запрос на формирование выписки по пос терминалам */
  orderPOSTerminalStatement: PosTerminalStatement;
  /** Запрос на формирование выписки по пос терминалу */
  orderPOSTerminalV2Statement: PosTerminalV2Statement;
}


export interface MutationOrderArgs {
  statementOrder: StatementOrder;
}


export interface MutationOrderCardStatementArgs {
  statementOrder: InputMaybe<CardStatementOrderDto>;
}


export interface MutationOrderPosTerminalStatementArgs {
  statementOrder: PosTerminalStatementOrder;
}


export interface MutationOrderPosTerminalV2StatementArgs {
  statementOrder: PosTerminalV2StatementOrder;
}

/** Пос терминалы */
export interface PosTerminal {
  __typename?: 'POSTerminal';
  /** Код например: PR908020, PR908023 */
  code: Scalars['String']['output'];
  /** Иденфикатор пос терминала */
  id: Scalars['Long']['output'];
}

/** Данные пос терминала */
export interface PosTerminalInput {
  /** Код например: PR908020, PR908023 */
  code: Scalars['String']['input'];
  /** Иденфикатор пос терминала */
  id: Scalars['Long']['input'];
}

/** Выписки по пос терминалам */
export interface PosTerminalStatement {
  __typename?: 'POSTerminalStatement';
  /** Операции в выписке от(до какой даты операции) */
  endDate: Scalars['Date']['output'];
  /** Текст об ошибки(если произошла ошибка при формировании выписки) */
  errorMessage: Maybe<Scalars['String']['output']>;
  /** Название файла выписки */
  fileName: Scalars['String']['output'];
  /** Айди записи */
  id: Scalars['Long']['output'];
  /** Айди организации */
  partyID: Scalars['Long']['output'];
  /** Список пос терминалов */
  posTerminalsByAddresses: Array<PosTerminalsByAddress>;
  /** Дата и время запроса на формирование выписки */
  requestDate: Scalars['DateTime']['output'];
  /** Операции в выписке от(с какой даты операции) */
  startDate: Scalars['Date']['output'];
  /** Текущий статус выписки */
  status: StatementStatus;
}

/** Для формирования выписке по пос терминалам */
export interface PosTerminalStatementOrder {
  /** Операции в выписке от(до какой даты операции) */
  endDate: Scalars['Date']['input'];
  /** Фильтровать по дате транзакции или по дате возмещения */
  isFilterByTransactionDate: InputMaybe<Scalars['Boolean']['input']>;
  /** Айди организации */
  partyID: Scalars['Long']['input'];
  /** Список пос терминалов по адресам */
  posTerminalsByAddresses: Array<PosTerminalsByAddressInput>;
  /** Формировать выписку только по операциям указанного QR-сервиса */
  qrServiceId: InputMaybe<Scalars['String']['input']>;
  /** Код торговой точки */
  salePointCode: InputMaybe<Scalars['Long']['input']>;
  /** Операции в выписке от(с какой даты операции) */
  startDate: Scalars['Date']['input'];
}

/** Выписка по пос терминалам в пагинации */
export interface PosTerminalStatementPaginationResponse {
  __typename?: 'POSTerminalStatementPaginationResponse';
  /** Текущая страница пагинации */
  currentPage: Scalars['Int']['output'];
  /** Кол-во элементов в текущей странице */
  elementsInCurrentPage: Scalars['Long']['output'];
  /** Список выписок по пос терминалам */
  posTerminalStatements: Array<PosTerminalStatement>;
  /** Общее кол-во данных */
  totalElements: Scalars['Long']['output'];
  /** Общее кол-во страниц пагинации */
  totalPages: Scalars['Int']['output'];
}

/** Выписки пос терминала для graphql подписок */
export interface PosTerminalSubscriptionResponse {
  __typename?: 'POSTerminalSubscriptionResponse';
  /** Выписки по пос терминалам */
  posTerminalStatement: PosTerminalStatement;
  /** События */
  subscriptionType: SubscriptionType;
}

/** Выписка по пос терминалу */
export interface PosTerminalV2Statement {
  __typename?: 'POSTerminalV2Statement';
  /** Операции в выписке от(до какой даты операции) */
  endDate: Scalars['Date']['output'];
  /** Текст об ошибки(если произошла ошибка при формировании выписки) */
  errorMessage: Maybe<Scalars['String']['output']>;
  /** Название файла выписки */
  fileName: Scalars['String']['output'];
  /** Айди записи */
  id: Scalars['Long']['output'];
  /** Дата и время запроса на формирование выписки */
  requestDateTime: Scalars['DateTime']['output'];
  /** Операции в выписке от(с какой даты операции) */
  startDate: Scalars['Date']['output'];
  /** Текущий статус выписки */
  status: StatementStatus;
  /** Код терминала */
  terminalCode: Scalars['String']['output'];
}

/** Для формирования выписки по пос терминалу */
export interface PosTerminalV2StatementOrder {
  /** Операции в выписке от(до какой даты операции) */
  endDate: Scalars['Date']['input'];
  /** Операции в выписке от(с какой даты операции) */
  startDate: Scalars['Date']['input'];
  /** Код терминала */
  terminalCode: Scalars['String']['input'];
}

/** Выписка по пос терминалам в пагинации */
export interface PosTerminalV2StatementPaginationResponse {
  __typename?: 'POSTerminalV2StatementPaginationResponse';
  /** Текущая страница пагинации */
  currentPage: Scalars['Int']['output'];
  /** Кол-во элементов в текущей странице */
  elementsInCurrentPage: Scalars['Long']['output'];
  /** Список выписок по пос терминалам */
  posTerminalV2Statements: Array<PosTerminalV2Statement>;
  /** Общее кол-во данных */
  totalElements: Scalars['Long']['output'];
  /** Общее кол-во страниц пагинации */
  totalPages: Scalars['Int']['output'];
}

/** Выписки пос терминалу для graphql подписок */
export interface PosTerminalV2SubscriptionResponse {
  __typename?: 'POSTerminalV2SubscriptionResponse';
  /** Выписки по пос терминалам */
  posTerminalV2Statement: PosTerminalV2Statement;
  /** События */
  subscriptionType: SubscriptionType;
}

/** Пос терминалы в адресе */
export interface PosTerminalsByAddress {
  __typename?: 'POSTerminalsByAddress';
  /** адрес */
  address: Scalars['String']['output'];
  /** список пос терминалов в адресе */
  posTerminals: Array<PosTerminal>;
}

/** Список пос терминалов с их адресом */
export interface PosTerminalsByAddressInput {
  /** адрес по которой находится пос терминал */
  address: Scalars['String']['input'];
  /** список самих пос терминало */
  posTerminals: Array<PosTerminalInput>;
}

/** Данные для пагинации */
export interface PaginationRequest {
  /** Кол-во страниц */
  page: Scalars['Int']['input'];
  /** Кол-во элементов на странице */
  size: Scalars['Int']['input'];
}

/** Выписки вместе с пагинацией */
export interface PaginationResponse {
  __typename?: 'PaginationResponse';
  /** Текущая страница пагинации */
  currentPage: Scalars['Int']['output'];
  /** Кол-во элементов в текущей странице пагинации */
  elementsInCurrentPage: Scalars['Long']['output'];
  /** Список выписок */
  statements: Array<Statement>;
  /** Общее кол-во элементов */
  totalElements: Scalars['Long']['output'];
  /** Общее кол-во страниц */
  totalPages: Scalars['Int']['output'];
}

/** Платежи */
export interface Payment {
  __typename?: 'Payment';
  counterpartyAccount: Maybe<Scalars['String']['output']>;
  counterpartyBank: Maybe<Scalars['String']['output']>;
  counterpartyName: Maybe<Scalars['String']['output']>;
  credit: Maybe<Scalars['String']['output']>;
  debit: Maybe<Scalars['String']['output']>;
  documentNumber: Maybe<Scalars['String']['output']>;
  paymentDate: Maybe<Scalars['Date']['output']>;
  /** Айди платежи */
  paymentID: Maybe<Scalars['Long']['output']>;
  paymentPurpose: Maybe<Scalars['String']['output']>;
  qrCreatedDate: Maybe<Scalars['String']['output']>;
}

export enum PaymentDirection {
  /** Пополнение */
  In = 'IN',
  /** Списание */
  Out = 'OUT'
}

/** Платежи с пагинацией */
export interface PaymentsResponse {
  __typename?: 'PaymentsResponse';
  /** Список аккаунтов */
  accounts: Array<Account>;
  /** Текущая страница */
  currentPage: Maybe<Scalars['Int']['output']>;
  /** Кол-во данных в текущей странице */
  elementsInCurrentPage: Maybe<Scalars['Long']['output']>;
  /** Операции в выписке от(до какой даты операции) */
  endDate: Scalars['Date']['output'];
  /** Дата и время отправки запроса */
  generateDate: Scalars['DateTime']['output'];
  /** Операции в выписке от(с какой даты операции) */
  startDate: Scalars['Date']['output'];
  /** Общее кол-во данных */
  totalElements: Maybe<Scalars['Long']['output']>;
  /** Общее кол-во страниц */
  totalPages: Maybe<Scalars['Int']['output']>;
}

export interface Query {
  __typename?: 'Query';
  /** Скачать файл с выпиской */
  download: File;
  /** Скачать файл с выпиской по пос терминалу */
  downloadPOSTerminalStatement: File;
  /** Скачать файл с выпиской по пос терминалу */
  downloadPOSTerminalV2Statement: File;
  /** Получение выписок клиента с пагинацией */
  findAll: PaginationResponse;
  /** Получение выписок с фильтрацией и пагинацией */
  findAllByFilter: PaginationResponse;
  /** Получение выписок по POS терминалам */
  findPOSTerminalStatements: PosTerminalStatementPaginationResponse;
  /** Получение выписок по POS терминалу */
  findPOSTerminalV2Statements: PosTerminalV2StatementPaginationResponse;
  /** Получение POS терминалов */
  getPOSTerminals: Array<PosTerminalsByAddress>;
  /** Получения операций для онлайн выписки */
  getPayments: PaymentsResponse;
  /** Получение операций для онлайн выписки по существующей выписке */
  getPaymentsByStatement: PaymentsResponse;
}


export interface QueryDownloadArgs {
  fileFormat: FileFormat;
  fileName: Scalars['String']['input'];
  language: InputMaybe<Language>;
  partyId: Scalars['Long']['input'];
}


export interface QueryDownloadPosTerminalStatementArgs {
  fileFormat: FileFormat;
  partyID: Scalars['Long']['input'];
  statementID: Scalars['Long']['input'];
}


export interface QueryDownloadPosTerminalV2StatementArgs {
  statementID: Scalars['Long']['input'];
  terminalCode: Scalars['String']['input'];
}


export interface QueryFindAllArgs {
  pagination: PaginationRequest;
  partyId: Scalars['Long']['input'];
}


export interface QueryFindAllByFilterArgs {
  pagination: PaginationRequest;
  statementFilter: StatementFilter;
}


export interface QueryFindPosTerminalStatementsArgs {
  pagination: PaginationRequest;
  partyID: Scalars['Long']['input'];
}


export interface QueryFindPosTerminalV2StatementsArgs {
  pagination: PaginationRequest;
  terminalCode: Scalars['String']['input'];
}


export interface QueryGetPosTerminalsArgs {
  partyID: Scalars['Long']['input'];
}


export interface QueryGetPaymentsArgs {
  pagination: PaginationRequest;
  parameters: StatementOrder;
}


export interface QueryGetPaymentsByStatementArgs {
  pagination: PaginationRequest;
  statementId: Scalars['Long']['input'];
}

/** Выписка */
export interface Statement {
  __typename?: 'Statement';
  /** Доступные счета у организации */
  availableAccounts: Array<AvailableAccount>;
  /** Валюты */
  currencies: Array<Scalars['String']['output']>;
  /** Операции в выписке от(до какой даты операции) */
  endDate: Scalars['Date']['output'];
  /** Текст ошибки, если произошла ошибка при формировании выписки */
  errorMessage: Maybe<Scalars['String']['output']>;
  /** Название файла для выписки */
  fileName: Scalars['String']['output'];
  /** Айди записи */
  id: Scalars['Long']['output'];
  /** Айди организации */
  partyId: Scalars['Long']['output'];
  /** Дата и время отправки запроса для формирование выписки */
  requestDate: Scalars['DateTime']['output'];
  /** Операции в выписке от(с какой даты операции) */
  startDate: Scalars['Date']['output'];
  /** Текущий статус выписки */
  status: StatementStatus;
}

export interface StatementFilter {
  /** Выписки начиная с этой даты */
  dateFrom: InputMaybe<Scalars['Date']['input']>;
  /** Айди организации */
  partyId: InputMaybe<Scalars['Long']['input']>;
  /** В каком статусе находится формирования выписки */
  statuses: Array<StatementStatus>;
}

/** Для формирования выписке */
export interface StatementOrder {
  /** Номер счета */
  account: InputMaybe<Scalars['String']['input']>;
  amountFrom: InputMaybe<Scalars['BigDecimal']['input']>;
  amountTo: InputMaybe<Scalars['BigDecimal']['input']>;
  /** iso_num валюты */
  currencies: Array<Scalars['Long']['input']>;
  documentNumber: InputMaybe<Scalars['String']['input']>;
  /** Операции в выписке от(до какой даты операции) */
  endDate: Scalars['Date']['input'];
  /** Айди организации */
  partyId: Scalars['Long']['input'];
  paymentDirection: InputMaybe<PaymentDirection>;
  /** Операции в выписке от(с какой даты операции) */
  startDate: Scalars['Date']['input'];
  statementType: InputMaybe<StatementType>;
}

/** Статусы формирования выписок */
export enum StatementStatus {
  /** При формировании произошла какая либо ошибка */
  Fail = 'FAIL',
  /**
   * Когда очередь получает заявку на формирование выписки, ставит статус IN_PROGRESS,
   * и начинает формировать соответствующую выписку
   */
  InProgress = 'IN_PROGRESS',
  /** При формировании выписки, данные вытаскиваем с БД, если данных нет, применяется данный статус */
  NotFound = 'NOT_FOUND',
  /**
   * Когда поступает запрос на формирования выписки, изначально ставится статус PENDING,
   * далее очереди для формирования выписки обрабатывают заявки только с этим статусом
   */
  Pending = 'PENDING',
  /** Очередь успешно сформировал выписку, применяется статус READY */
  Ready = 'READY'
}

export enum StatementType {
  /** Без детализации QR-операций */
  WithoutQrDetails = 'WITHOUT_QR_DETAILS',
  /** C детализацией QR-операций */
  WithQrDetails = 'WITH_QR_DETAILS'
}

export interface Subscription {
  __typename?: 'Subscription';
  /** Подписка на выписки */
  listen: SubscriptionResponse;
  /** Подписка */
  listenCardStatement: SubscriptionResponse;
  /** Подписка на выписки по пос терминалам */
  listenPOSTerminalStatement: PosTerminalSubscriptionResponse;
  /** Подписка на выписки по пос терминалу */
  listenPOSTerminalV2Statement: PosTerminalV2SubscriptionResponse;
}


export interface SubscriptionListenArgs {
  partyId: Scalars['Long']['input'];
}


export interface SubscriptionListenCardStatementArgs {
  partyId: Scalars['Long']['input'];
}


export interface SubscriptionListenPosTerminalStatementArgs {
  partyID: Scalars['Long']['input'];
}


export interface SubscriptionListenPosTerminalV2StatementArgs {
  terminalCode: Scalars['String']['input'];
}

/** Выписки для graphql подписок */
export interface SubscriptionResponse {
  __typename?: 'SubscriptionResponse';
  /** Выписка */
  statement: Statement;
  /** События */
  subscriptionType: Maybe<SubscriptionType>;
}

/** Виды событий */
export enum SubscriptionType {
  /** Удален */
  Delete = 'DELETE',
  /** Изменен */
  Update = 'UPDATE'
}

export type StatementFragment = { __typename?: 'Statement', id: number, partyId: number, startDate: string, endDate: string, status: StatementStatus, fileName: string, requestDate: any, availableAccounts: Array<{ __typename?: 'AvailableAccount', account: string, currencies: Array<number> }> };

export type PosTerminalStatementFragment = { __typename?: 'POSTerminalStatement', id: number, requestDate: any, partyID: number, startDate: string, endDate: string, fileName: string, status: StatementStatus, errorMessage: string | null, posTerminalsByAddresses: Array<{ __typename?: 'POSTerminalsByAddress', address: string, posTerminals: Array<{ __typename?: 'POSTerminal', id: number, code: string }> }> };

export type PosTerminalFragment = { __typename?: 'POSTerminal', id: number, code: string };

export type PosTerminalsByAddressFragment = { __typename?: 'POSTerminalsByAddress', address: string, posTerminals: Array<{ __typename?: 'POSTerminal', id: number, code: string }> };

export type PosTerminalStatementPaginationFragment = { __typename?: 'POSTerminalStatementPaginationResponse', currentPage: number, elementsInCurrentPage: number, totalPages: number, totalElements: number, posTerminalStatements: Array<{ __typename?: 'POSTerminalStatement', id: number, requestDate: any, partyID: number, startDate: string, endDate: string, fileName: string, status: StatementStatus, errorMessage: string | null, posTerminalsByAddresses: Array<{ __typename?: 'POSTerminalsByAddress', address: string, posTerminals: Array<{ __typename?: 'POSTerminal', id: number, code: string }> }> }> };

export type StatementBriefFragment = { __typename?: 'Statement', id: number, status: StatementStatus };

export type FileFragment = { __typename?: 'File', fileName: string, contentType: string, data: string };

export type PaginationStatementFragment = { __typename?: 'PaginationResponse', currentPage: number, totalPages: number, statements: Array<{ __typename?: 'Statement', id: number, partyId: number, startDate: string, endDate: string, status: StatementStatus, fileName: string, requestDate: any, availableAccounts: Array<{ __typename?: 'AvailableAccount', account: string, currencies: Array<number> }> }> };

export type OrderMutationVariables = Exact<{
  statementOrder: StatementOrder;
}>;


export type OrderMutation = { __typename?: 'Mutation', order: { __typename?: 'Statement', id: number, partyId: number, startDate: string, endDate: string, status: StatementStatus, fileName: string, requestDate: any, availableAccounts: Array<{ __typename?: 'AvailableAccount', account: string, currencies: Array<number> }> } };

export type OrderPosTerminalStatementMutationVariables = Exact<{
  statementOrder: PosTerminalStatementOrder;
}>;


export type OrderPosTerminalStatementMutation = { __typename?: 'Mutation', orderPOSTerminalStatement: { __typename?: 'POSTerminalStatement', id: number, requestDate: any, partyID: number, startDate: string, endDate: string, fileName: string, status: StatementStatus, errorMessage: string | null, posTerminalsByAddresses: Array<{ __typename?: 'POSTerminalsByAddress', address: string, posTerminals: Array<{ __typename?: 'POSTerminal', id: number, code: string }> }> } };

export type OrderCardStatementMutationVariables = Exact<{
  statementOrder: InputMaybe<CardStatementOrderDto>;
}>;


export type OrderCardStatementMutation = { __typename?: 'Mutation', orderCardStatement: { __typename?: 'File', fileName: string, contentType: string, data: string } };

export type FindAllQueryVariables = Exact<{
  partyId: Scalars['Long']['input'];
  pagination: PaginationRequest;
}>;


export type FindAllQuery = { __typename?: 'Query', findAll: { __typename?: 'PaginationResponse', currentPage: number, totalPages: number, statements: Array<{ __typename?: 'Statement', id: number, partyId: number, startDate: string, endDate: string, status: StatementStatus, fileName: string, requestDate: any, availableAccounts: Array<{ __typename?: 'AvailableAccount', account: string, currencies: Array<number> }> }> } };

export type FindPosTerminalStatementsQueryVariables = Exact<{
  partyId: Scalars['Long']['input'];
  pagination: PaginationRequest;
}>;


export type FindPosTerminalStatementsQuery = { __typename?: 'Query', findPOSTerminalStatements: { __typename?: 'POSTerminalStatementPaginationResponse', currentPage: number, elementsInCurrentPage: number, totalPages: number, totalElements: number, posTerminalStatements: Array<{ __typename?: 'POSTerminalStatement', id: number, requestDate: any, partyID: number, startDate: string, endDate: string, fileName: string, status: StatementStatus, errorMessage: string | null, posTerminalsByAddresses: Array<{ __typename?: 'POSTerminalsByAddress', address: string, posTerminals: Array<{ __typename?: 'POSTerminal', id: number, code: string }> }> }> } };

export type GetPosTerminalsQueryVariables = Exact<{
  partyID: Scalars['Long']['input'];
}>;


export type GetPosTerminalsQuery = { __typename?: 'Query', getPOSTerminals: Array<{ __typename?: 'POSTerminalsByAddress', address: string, posTerminals: Array<{ __typename?: 'POSTerminal', id: number, code: string }> }> };

export type DownloadPosTerminalStatementQueryVariables = Exact<{
  statementID: Scalars['Long']['input'];
  partyID: Scalars['Long']['input'];
  fileFormat: FileFormat;
}>;


export type DownloadPosTerminalStatementQuery = { __typename?: 'Query', downloadPOSTerminalStatement: { __typename?: 'File', fileName: string, contentType: string, data: string } };

export type DownloadQueryVariables = Exact<{
  fileName: Scalars['String']['input'];
  fileFormat: FileFormat;
  partyId: Scalars['Long']['input'];
}>;


export type DownloadQuery = { __typename?: 'Query', download: { __typename?: 'File', fileName: string, contentType: string, data: string } };

export type ListenSubscriptionVariables = Exact<{
  partyId: Scalars['Long']['input'];
}>;


export type ListenSubscription = { __typename?: 'Subscription', listen: { __typename?: 'SubscriptionResponse', subscriptionType: SubscriptionType | null, statement: { __typename?: 'Statement', id: number, status: StatementStatus } } };

export type ListenPosTerminalStatementSubscriptionVariables = Exact<{
  partyID: Scalars['Long']['input'];
}>;


export type ListenPosTerminalStatementSubscription = { __typename?: 'Subscription', listenPOSTerminalStatement: { __typename?: 'POSTerminalSubscriptionResponse', subscriptionType: SubscriptionType, posTerminalStatement: { __typename?: 'POSTerminalStatement', id: number, requestDate: any, partyID: number, startDate: string, endDate: string, fileName: string, status: StatementStatus, errorMessage: string | null, posTerminalsByAddresses: Array<{ __typename?: 'POSTerminalsByAddress', address: string, posTerminals: Array<{ __typename?: 'POSTerminal', id: number, code: string }> }> } } };

export const PosTerminalFragmentDoc = gql`
    fragment POSTerminal on POSTerminal {
  id
  code
}
    `;
export const PosTerminalsByAddressFragmentDoc = gql`
    fragment POSTerminalsByAddress on POSTerminalsByAddress {
  address
  posTerminals {
    ...POSTerminal
  }
}
    ${PosTerminalFragmentDoc}`;
export const PosTerminalStatementFragmentDoc = gql`
    fragment POSTerminalStatement on POSTerminalStatement {
  id
  posTerminalsByAddresses {
    ...POSTerminalsByAddress
  }
  requestDate
  partyID
  startDate
  endDate
  fileName
  status
  errorMessage
}
    ${PosTerminalsByAddressFragmentDoc}`;
export const PosTerminalStatementPaginationFragmentDoc = gql`
    fragment POSTerminalStatementPagination on POSTerminalStatementPaginationResponse {
  currentPage
  elementsInCurrentPage
  totalPages
  totalElements
  posTerminalStatements {
    ...POSTerminalStatement
  }
}
    ${PosTerminalStatementFragmentDoc}`;
export const StatementBriefFragmentDoc = gql`
    fragment StatementBrief on Statement {
  id
  status
}
    `;
export const FileFragmentDoc = gql`
    fragment File on File {
  fileName
  contentType
  data
}
    `;
export const StatementFragmentDoc = gql`
    fragment Statement on Statement {
  id
  partyId
  availableAccounts {
    account
    currencies
  }
  startDate
  endDate
  status
  fileName
  requestDate
}
    `;
export const PaginationStatementFragmentDoc = gql`
    fragment PaginationStatement on PaginationResponse {
  currentPage
  totalPages
  statements {
    ...Statement
  }
}
    ${StatementFragmentDoc}`;
export const OrderDocument = gql`
    mutation order($statementOrder: StatementOrder!) {
  order(statementOrder: $statementOrder) {
    ...Statement
  }
}
    ${StatementFragmentDoc}`;
export const OrderPosTerminalStatementDocument = gql`
    mutation orderPOSTerminalStatement($statementOrder: POSTerminalStatementOrder!) {
  orderPOSTerminalStatement(statementOrder: $statementOrder) {
    ...POSTerminalStatement
  }
}
    ${PosTerminalStatementFragmentDoc}`;
export const OrderCardStatementDocument = gql`
    mutation orderCardStatement($statementOrder: CardStatementOrderDto) {
  orderCardStatement(statementOrder: $statementOrder) {
    ...File
  }
}
    ${FileFragmentDoc}`;
export const FindAllDocument = gql`
    query findAll($partyId: Long!, $pagination: PaginationRequest!) {
  findAll(partyId: $partyId, pagination: $pagination) {
    ...PaginationStatement
  }
}
    ${PaginationStatementFragmentDoc}`;
export const FindPosTerminalStatementsDocument = gql`
    query findPOSTerminalStatements($partyId: Long!, $pagination: PaginationRequest!) {
  findPOSTerminalStatements(partyID: $partyId, pagination: $pagination) {
    ...POSTerminalStatementPagination
  }
}
    ${PosTerminalStatementPaginationFragmentDoc}`;
export const GetPosTerminalsDocument = gql`
    query getPOSTerminals($partyID: Long!) {
  getPOSTerminals(partyID: $partyID) {
    ...POSTerminalsByAddress
  }
}
    ${PosTerminalsByAddressFragmentDoc}`;
export const DownloadPosTerminalStatementDocument = gql`
    query downloadPOSTerminalStatement($statementID: Long!, $partyID: Long!, $fileFormat: FileFormat!) {
  downloadPOSTerminalStatement(
    statementID: $statementID
    partyID: $partyID
    fileFormat: $fileFormat
  ) {
    ...File
  }
}
    ${FileFragmentDoc}`;
export const DownloadDocument = gql`
    query download($fileName: String!, $fileFormat: FileFormat!, $partyId: Long!) {
  download(fileName: $fileName, fileFormat: $fileFormat, partyId: $partyId) {
    ...File
  }
}
    ${FileFragmentDoc}`;
export const ListenDocument = gql`
    subscription listen($partyId: Long!) {
  listen(partyId: $partyId) {
    statement {
      ...StatementBrief
    }
    subscriptionType
  }
}
    ${StatementBriefFragmentDoc}`;
export const ListenPosTerminalStatementDocument = gql`
    subscription listenPOSTerminalStatement($partyID: Long!) {
  listenPOSTerminalStatement(partyID: $partyID) {
    posTerminalStatement {
      ...POSTerminalStatement
    }
    subscriptionType
  }
}
    ${PosTerminalStatementFragmentDoc}`;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    order(variables: OrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderMutation>(OrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'order', 'mutation', variables);
    },
    orderPOSTerminalStatement(variables: OrderPosTerminalStatementMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderPosTerminalStatementMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderPosTerminalStatementMutation>(OrderPosTerminalStatementDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderPOSTerminalStatement', 'mutation', variables);
    },
    orderCardStatement(variables?: OrderCardStatementMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderCardStatementMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderCardStatementMutation>(OrderCardStatementDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderCardStatement', 'mutation', variables);
    },
    findAll(variables: FindAllQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindAllQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindAllQuery>(FindAllDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findAll', 'query', variables);
    },
    findPOSTerminalStatements(variables: FindPosTerminalStatementsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindPosTerminalStatementsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindPosTerminalStatementsQuery>(FindPosTerminalStatementsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findPOSTerminalStatements', 'query', variables);
    },
    getPOSTerminals(variables: GetPosTerminalsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPosTerminalsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPosTerminalsQuery>(GetPosTerminalsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPOSTerminals', 'query', variables);
    },
    downloadPOSTerminalStatement(variables: DownloadPosTerminalStatementQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DownloadPosTerminalStatementQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DownloadPosTerminalStatementQuery>(DownloadPosTerminalStatementDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'downloadPOSTerminalStatement', 'query', variables);
    },
    download(variables: DownloadQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DownloadQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DownloadQuery>(DownloadDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'download', 'query', variables);
    },
    listen(variables: ListenSubscriptionVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ListenSubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<ListenSubscription>(ListenDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'listen', 'subscription', variables);
    },
    listenPOSTerminalStatement(variables: ListenPosTerminalStatementSubscriptionVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ListenPosTerminalStatementSubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<ListenPosTerminalStatementSubscription>(ListenPosTerminalStatementDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'listenPOSTerminalStatement', 'subscription', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;